/* tslint:disable */
/* eslint-disable */
import * as runtime from '../runtime';
import type {
  BankAccount,
} from '../models/index';
import {
    BankAccountFromJSON,
    BankAccountToJSON,
} from '../models/index';

export interface BankAccountCreateRequest {
    data?: BankAccount;
}

export interface BankAccountDeleteByIdRequest {
    id: string;
}

export interface BankAccountFindRequest {
    filter?: string;
}

export interface BankAccountFindByIdRequest {
    id: string;
    filter?: string;
}

export interface BankAccountPrototypePatchAttributesRequest {
    id: string;
    data?: BankAccount;
}

export class BankAccountApi extends runtime.BaseAPI {

    async bankAccountCreateRaw(requestParameters: BankAccountCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankAccount>> {
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/BankAccounts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BankAccountToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BankAccountFromJSON(jsonValue));
    }

    async bankAccountCreate(requestParameters: BankAccountCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankAccount> {
        const response = await this.bankAccountCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async bankAccountDeleteByIdRaw(requestParameters: BankAccountDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling bankAccountDeleteById().');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        const response = await this.request({
            path: `/BankAccounts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse<any>(response);
    }

    async bankAccountDeleteById(requestParameters: BankAccountDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.bankAccountDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async bankAccountFindRaw(requestParameters: BankAccountFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BankAccount>>> {
        const queryParameters: any = {};
        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }
        const headerParameters: runtime.HTTPHeaders = {};
        const response = await this.request({
            path: `/BankAccounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BankAccountFromJSON));
    }

    async bankAccountFind(requestParameters: BankAccountFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BankAccount>> {
        const response = await this.bankAccountFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async bankAccountFindByIdRaw(requestParameters: BankAccountFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling bankAccountFindById().');
        }
        const queryParameters: any = {};
        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }
        const headerParameters: runtime.HTTPHeaders = {};
        const response = await this.request({
            path: `/BankAccounts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BankAccountFromJSON(jsonValue));
    }

    async bankAccountFindById(requestParameters: BankAccountFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankAccount> {
        const response = await this.bankAccountFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    async bankAccountPrototypePatchAttributesRaw(requestParameters: BankAccountPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BankAccount>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling bankAccountPrototypePatchAttributes().');
        }
        const queryParameters: any = {};
        const headerParameters: runtime.HTTPHeaders = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/BankAccounts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: BankAccountToJSON(requestParameters['data']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BankAccountFromJSON(jsonValue));
    }

    async bankAccountPrototypePatchAttributes(requestParameters: BankAccountPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BankAccount> {
        const response = await this.bankAccountPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
